import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import helper from "./mixins/helper";
import "@mdi/font/css/materialdesignicons.css";
import ToastPlugin from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { VsxIcon } from "vue-iconsax";

const app = createApp(App);
app.use(ToastPlugin);
app.mixin(helper);
app.use(vuetify);
app.use(router);
app.use(store);
app.component("VsxIcon", VsxIcon);
app.use(ElementPlus)
app.mount("#app");
